module.exports = __webpack_public_path__ + "ddc7c1e9f7f280e504de875ac98c59d5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/esrb-store-footer.png
// module id = 277
// module chunks = 0